<template>
<b-container fluid>
    <PortalNavbar v-if="!isLoggedIn"></PortalNavbar>
    <b-container>
        
        <br/>
        <h2 class="text-primary">Privacy Policy</h2>
        <br/>
        <div class="row">

            <div class="col-md-12">
                <div align="justify">
                    
                    <p>
                        We maintain full privacy of your personal information shared with us. We never misuse any of your personal information. Our privacy policy is as given below:
                    </p>
                    <p>
                        <strong>1.  Collection and Sharing of customer information: </strong>
                        We collect information from you only after you agree to provide it. Any information you give us is held with care and security. This information is collected primarily to ensure that we ship your products without any hassles.
                        <br/>
                        We may collect your title, name, gender, email address, postal address, delivery address (if different), telephone number, mobile number, fax number, payment details or bank account details. All this information is processed securely for your protection.
                        <br/>
                        Your actual order details may be stored with us and you may access this information by logging into your account on the Site. You undertake to treat the personal access data confidentially and not make it available to unauthorized third parties.
                        <br/>
                        Under no circumstances do we rent, trade or share your personal information that we have collected with any other company for their marketing purposes without your consent. We reserve the right to communicate your personal information to any third party that makes a legally-compliant request for its disclosure.
                    <p>
                        <strong>2.  Intellectual Property Rights:: </strong>
                        All content included on this site, such as text, graphics, logos, button icons, images and software, is the property of CERISETECH SOLUTIONS PVT. LTD. All content on the Site that is not the property of CERISETECH SOLUTIONS PVT. LTD is used with permission.
                    </p>

                </div>
            </div>

        </div>

    </b-container>
</b-container>
</template>
<script>
import PortalNavbar from "@/components/PortalNavbar";

export default {
  components: { PortalNavbar },
  computed: {
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Policy.vue